import { chain } from '@leprecoins/effector';
import { combine, createStore, sample } from 'effector';
import { empty } from 'patronum';
import { createEditGameSettingModel } from 'features/edit-game-setting';
import { createResetGameSettingModel } from 'features/reset-game-setting';
import { accountTreeModel } from 'entities/account';
import { createGameSettingRegistryModel } from 'entities/game-setting';
import { createGetGamesQuery } from 'shared/api';
import { accountPageModel } from './account-page-model';

const getGamesQuery = createGetGamesQuery();

const $games = getGamesQuery.$data.map((games) =>
	games ? games.map((game) => ({ value: `${game.id}`, label: game.title })) : [],
);

const $gameId = createStore<number | null>(null);

const $game = combine(
	{
		gameId: $gameId,
		games: getGamesQuery.$data,
	},
	({ gameId, games }) => games?.find((game) => game.id === gameId) ?? null,
);

const resetGameSettingModel = createResetGameSettingModel();

const editGameSettingModel = createEditGameSettingModel();

const gameSettingRegistryModel = createGameSettingRegistryModel({
	$currencies: accountTreeModel.$currencies,
	$accountId: accountPageModel.$accountId,
	$gameId,
	disabled: empty($gameId),
	onUpdate: [
		$gameId,
		accountPageModel.accountIdSet,
		resetGameSettingModel.mutation.finished.success,
		editGameSettingModel.editGameSettingsMutation.finished.success,
	],
});

sample({
	clock: accountPageModel.accountIdSet,
	source: gameSettingRegistryModel.model.gate.status,
	filter: Boolean,
	target: getGamesQuery.start,
});

chain(gameSettingRegistryModel.model.gate.open, getGamesQuery.start);

chain(gameSettingRegistryModel.model.gate.close, getGamesQuery.reset);

sample({
	clock: getGamesQuery.finished.success,
	fn: ({ result }) => result[0]?.id,
	target: $gameId,
});

export const accountPageGameSettingsModel = {
	$games,
	$gameId,
	$game,
	gameSettingRegistryModel,
	resetGameSettingModel,
	editGameSettingModel,
};
